(function() {
	// Set up touch event -> mouse event emulation.

	return;
		
	if ('TouchEvent' in window) {
		// We support the TouchEvent interface.

		var whichTouch = null;
		var ourClickEvent = null;
		var mouseTarget = null;
		var gotFocusInMousePath = false;
		var whatIsFocused = false;
		
		var doneTooltip;
		var removeTooltip;
		var scrollTimeout;
		
		function debugMessage_ignored() {}
		function debugMessage_logged() { console.log.apply(console, arguments); }
		var debugMessage = /DEBUG=1/.test(location.href) ? debugMessage_logged : debugMessage_ignored;
		
		function documentScrollHandler() {
			clearTimeout(scrollTimeout);
			document.querySelector('#doneTooltip .tooltip').style.top = (document.body.scrollTop + window.innerHeight - 265) + 'px';
			scrollTimeout = setTimeout(documentScrollHandler, 50);
		}
		
		document.documentElement.addEventListener('focus', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got focus event (capture) on document: ", event, event.target);
			
			if (whichTouch) {
				gotFocusInMousePath = true;
				whatIsFocused = event.target;
				var n = event.target;
				if (n.id && !$(n).is('input[type=file]')) {
					try {
						var label = document.querySelector('label[for="' + n.id + '"]');
						if (label) {
							label.parentNode.scrollIntoView();
						}
					} catch (e) {
						;
					}
					if (false && (/iPhone/.test(navigator.userAgent) || /iPod/.test(navigator.userAgent))) {
						if (n.nodeName.toLowerCase() == 'select') {
							if (removeTooltip) {
								clearTimeout(removeTooltip);
							}
							if (!doneTooltip) {
								var t = document.createElement('div');
								t.id = 'doneTooltip';
								t.innerHTML = "\
									<div class='tooltip fade top' style='position: absolute; top: 0; right: 5px; display: block;'>\
										<div class='tooltip-arrow' style='right: 15px; left: auto;'></div>\
										<div class='tooltip-inner'>Touch \"Done\" when you are finished</div>\
									</div>\
								";
								document.body.appendChild(t);
								doneTooltip = t;
								// document.body.addEventListener('scroll', documentScrollHandler, false);
								documentScrollHandler();
								document.querySelector('#doneTooltip .tooltip').className = 'tooltip fade top in';
							} else {
								documentScrollHandler();
							}
						}
					}
				}
			}
		}, true);

		document.documentElement.addEventListener('blur', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got blur event (capture) on document: ", event, event.target);
			whatIsFocused = null;
			clearTimeout(scrollTimeout);
			if (removeTooltip) clearTimeout(removeTooltip);
			if (doneTooltip) {
				removeTooltip = setTimeout(function() {
					doneTooltip.parentNode.removeChild(doneTooltip);
					doneTooltip = null;
				}, 16);
			}
		}, true);

		document.documentElement.addEventListener('change', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got change event (capture) on document: ", event, event.target, event.target.value);
		}, true);

		document.documentElement.addEventListener('mouseover', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got mouseover event (capture) on document: ", event, event.target);
		}, true);
		document.documentElement.addEventListener('mouseout', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got mouseout event (capture) on document: ", event, event.target);
		}, true);
		
		// Run this in capturing mode.
		document.documentElement.addEventListener('click', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got click event (capture) on document: ", event, event.target);

			if (ourClickEvent) {
				if (event != ourClickEvent) {
					debugMessage("Stopping click event: ", event);
					event.stopPropagation();
					event.preventDefault();
				}
			}
		}, true);

		document.documentElement.addEventListener('click', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got click event on document: ", event, event.target, event == ourClickEvent);
		}, false);
			
		document.documentElement.addEventListener('touchstart', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got touchstart event on document: ", event, event.target);

			if (whatIsFocused) {
				debugMessage("Ignore touchstart: focus on ", whatIsFocused);
				whichTouch = null;
				ourClickEvent = null;
				return;
			}
			
			if (!whatIsFocused && event.touches.length == 1) {
				whichTouch = { 
					screenX: event.touches[0].screenX, 
					screenY: event.touches[0].screenY, 
					clientX: event.touches[0].clientX,
					clientY: event.touches[0].clientY,
					id: event.touches[0].identifier 
				};
				
				// Turn 'touchstart' into 'mouseover', 'mouseenter', 'mousedown'.

				var element = document.elementFromPoint(whichTouch.clientX, whichTouch.clientY);
				
				if (mouseTarget) {
					var mouseOut = document.createEvent('MouseEvent');
					mouseOut.initMouseEvent('mouseout', true, true, window, 0, whichTouch.screenX, whichTouch.screenY, whichTouch.clientX, whichTouch.clientY, false, false, false, false, 0, element);
					mouseTarget.dispatchEvent(mouseOut);
				}
				
				var mouseOver = document.createEvent('MouseEvent');
				mouseOver.initMouseEvent('mouseover', true, true, window, 0, whichTouch.screenX, whichTouch.screenY, whichTouch.clientX, whichTouch.clientY, false, false, false, false, 0, mouseTarget || document.documentElement);

				mouseTarget = element;
				
				var mouseDown = document.createEvent('MouseEvent');
				mouseDown.initMouseEvent('mousedown', true, true, window, 1, whichTouch.screenX, whichTouch.screenY, whichTouch.clientX, whichTouch.clientY, false, false, false, false, 0, null);
				
				if (!element)
					return;
				
				whichTouch.element = element;
				gotFocusInMousePath = false;
				ourClickEvent = null;
				
				debugMessage("Dispatch mousedown at ", element);

				element.dispatchEvent(mouseOver);
				var r = element.dispatchEvent(mouseDown);
				
				if (!r) {
					debugMessage("mousedown cancelled.");
					whichTouch = null;
				} else {
					// event.preventDefault();
				}
			}
		}, false);
		
		document.documentElement.addEventListener('touchend', function(event) {
			if ($(event.target).parents("[data-auto-touch=false]").length) return;

			debugMessage("Got touchend event on document: ", event, event.target);

			if (whichTouch) {
				var theTouch;
				for (var i = 0; i < event.changedTouches.length; i++) {
					if (event.changedTouches[i].identifier == whichTouch.id) {
						theTouch = event.changedTouches[i];
						break;
					}
				}
				if (!theTouch) {
					debugMessage("Skip mouseup handler: ", whichTouch, event);
					return;
				}
				
				var target = document.elementFromPoint(theTouch.clientX, theTouch.clientY);
				if (gotFocusInMousePath) {
					target = whichTouch.element; // Ignore the fact that the screen moved.
				}
				if (!target)
					return;

				event.preventDefault();
									
				var mouseUp = document.createEvent('MouseEvent');
				mouseUp.initEvent('mouseup', true, true, window, 1, theTouch.screenX, theTouch.screenY, theTouch.clientX, theTouch.clientY, false, false, false, false, 0, null);
				debugMessage("Dispatch mouseup at ", target);
				var r = target.dispatchEvent(mouseUp);

				if (r) {
					if (Math.abs(theTouch.clientX - whichTouch.clientX) <= 30 && Math.abs(theTouch.clientY - whichTouch.clientY) <= 30) {
						var formFields = [ 'button', 'input', 'keygen', 'meter', 'select', 'textarea' ];
						// Is the target contained within a 'label' element? If so, retarget to the node specified by 'for', if it's not there.
						var isLabel = null;
						for (var i = target; i; i = i.parentNode) {
							if (formFields.indexOf(i.nodeName.toLowerCase()) != -1 || i.nodeName.toLowerCase() == 'a') {
								// It was directly on the form control, or a link contained in a label.
								break;
							}
							
							if (i.nodeName.toLowerCase() == 'label') {
								if (i.hasAttribute('for')) {
									var ff = document.getElementById(i.getAttribute('for'));
									if (ff && formFields.indexOf(ff.nodeName.toLowerCase()) != -1) {
										target = ff;
										break;
									}
								}
								for (var j = 0; j < formFields.length; j++) {
									var t = i.getElementsByTagName(formFields[j]);
									if (t.length) {
										target = t[0];
										break;
									}
								}
							}
						}
						
						debugMessage("Dispatch click at ", target);
						var click = document.createEvent('MouseEvent');
						click.initEvent('click', true, true, window, 1, theTouch.screenX, theTouch.screenY, theTouch.clientX, theTouch.clientY, false, false, false, false, 0, null);
						ourClickEvent = click;
						
						var r2 = target.dispatchEvent(click);
						// ourClickEvent = null;
						if (r2) {
							var e = target;
							do {
								if (e.nodeName.toLowerCase() == 'a' && e.hasAttribute('href')) {
									if (e.hasAttribute('target')) {
										var target = e.getAttribute('target');
										if (target != '_self') {
											// window.open(e.href, target);
											return;
										}
									}
									location.href = e.href;
									return;
								}
								if (formFields.indexOf(e.nodeName.toLowerCase()) != -1) {
									switch (e.type) {
										case 'checkbox':
											this.checked = !this.checked;
											return;
										case 'radio':
											// Clicking a radio button always selects it. The browser handles the case of multiple radio buttons.
											this.checked = true;
											return;
										case 'button':
										case 'submit':
											break;
										
										default:
											e.focus();
											return;
									}
								}
								if ((e.nodeName.toLowerCase() == 'button' || e.nodeName.toLowerCase() == 'input') && e.getAttribute('type') == 'submit') {
									var theForm = e;
									while (theForm && theForm.nodeName.toLowerCase() != 'form') {
										theForm = theForm.parentNode;
									}
									if (theForm) {
										theForm.submit();
									}
									return;
								}
								
								e = e.parentNode;
							} while (e);
						}
					}
				}
			}
		}, false);
	}
})();
